/**
 * @generated SignedSource<<41fb453791ea25afe607abc5a08a2b4f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type MessageBannerContent_viewer$data = {
  readonly activePromotion: {
    readonly " $fragmentSpreads": FragmentRefs<"messageHelpers_promotion">;
  } | null;
  readonly expiringPromotion: {
    readonly " $fragmentSpreads": FragmentRefs<"messageHelpers_expiringPromotion">;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"promoHelpers_trackGeoLocationPromos_viewer">;
  readonly " $fragmentType": "MessageBannerContent_viewer";
};
export type MessageBannerContent_viewer$key = {
  readonly " $data"?: MessageBannerContent_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"MessageBannerContent_viewer">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "RootArgument",
  "name": "userId"
},
v1 = {
  "kind": "Variable",
  "name": "userId",
  "variableName": "userId"
},
v2 = [
  (v1/*: any*/)
];
return {
  "argumentDefinitions": [
    (v0/*: any*/)
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "MessageBannerContent_viewer",
  "selections": [
    {
      "alias": null,
      "args": (v2/*: any*/),
      "concreteType": "Promotion",
      "kind": "LinkedField",
      "name": "activePromotion",
      "plural": false,
      "selections": [
        {
          "kind": "InlineDataFragmentSpread",
          "name": "messageHelpers_promotion",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "serviceId",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "buyerDisplayable",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "FlatAdjustmentRate",
              "kind": "LinkedField",
              "name": "flatAdjustmentRate",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "FinancialAmount",
                  "kind": "LinkedField",
                  "name": "rate",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "ConvertedAmountList",
                      "kind": "LinkedField",
                      "name": "convertedAmountList",
                      "plural": true,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "amount",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "currency",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "code",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "PromotionMeta",
              "kind": "LinkedField",
              "name": "promotionMeta",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "customBannerMessage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "desktopBannerMessage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "desktopBannerCta",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "mobileBannerMessage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "mobileBannerCta",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "args": null,
          "argumentDefinitions": []
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": (v2/*: any*/),
      "concreteType": "Promotion",
      "kind": "LinkedField",
      "name": "expiringPromotion",
      "plural": false,
      "selections": [
        {
          "kind": "InlineDataFragmentSpread",
          "name": "messageHelpers_expiringPromotion",
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "ExpiringPromoMessage_promotion"
            },
            {
              "kind": "InlineDataFragmentSpread",
              "name": "expiringPromoMessageHelpers_expiringPromotion",
              "selections": [
                {
                  "alias": null,
                  "args": [
                    {
                      "kind": "Literal",
                      "name": "truncate",
                      "value": false
                    }
                  ],
                  "kind": "ScalarField",
                  "name": "daysRelativeToExpiration",
                  "storageKey": "daysRelativeToExpiration(truncate:false)"
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "PromotionMeta",
                  "kind": "LinkedField",
                  "name": "promotionMeta",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "urgencyMessagingDisplay",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "urgencyMessagingDaysBeforeExpiration",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "args": null,
              "argumentDefinitions": []
            }
          ],
          "args": null,
          "argumentDefinitions": []
        }
      ],
      "storageKey": null
    },
    {
      "kind": "InlineDataFragmentSpread",
      "name": "promoHelpers_trackGeoLocationPromos_viewer",
      "selections": [
        {
          "condition": "isGeoLocationPromoGroupSet",
          "kind": "Condition",
          "passingValue": false,
          "selections": [
            {
              "alias": null,
              "args": [
                {
                  "kind": "Literal",
                  "name": "listTypes",
                  "value": [
                    "ABTEST_PROMOTIONS"
                  ]
                },
                (v1/*: any*/)
              ],
              "concreteType": "PromotionVariantControl",
              "kind": "LinkedField",
              "name": "promotionVariantControl",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "promoGroup",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "promotionCode",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ]
        }
      ],
      "args": null,
      "argumentDefinitions": [
        {
          "kind": "RootArgument",
          "name": "isGeoLocationPromoGroupSet"
        },
        (v0/*: any*/)
      ]
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};
})();

(node as any).hash = "0f7255eae38b46ca7a95aa5232a91746";

export default node;
